/**
 * Allowed file types for KNOWLEDGE uploads — data bundles, skills, and
 * agent/tenant context.
 *
 * MUST mirror the backend allowlist in backend/app/constants.py
 * (KNOWLEDGE_ALLOWED_EXTENSIONS). The backend is the real gate; this only
 * filters the native file picker for a better UX. Notably excludes .html/.htm.
 */
export const KNOWLEDGE_ACCEPT =
  '.txt,.md,.json,.pdf,.doc,.docx,.xlsx,.xlsm,.xls,.csv,.tsv,.pptx,.pages,.numbers,.key';
